import { useState } from 'react';

import { TChannelProtocol, TChannelTypeGroup } from '@/entities/channel';
import { ValueOf } from '@/shared/globalTypes';

export const STEP = {
  CLOSED: 'CLOSED',
  SELECT_CHANNEL_TYPE: 'SELECT_CHANNEL_TYPE',
  SELECT_CHANNEL_PROTOCOL: 'SELECT_CHANNEL_PROTOCOL',
  BILLING: 'BILLING',
  SELECT_COMPANY: 'SELECT_COMPANY',
} as const;

export type TChannelStep = ValueOf<typeof STEP>;

export const useChannelSteps = () => {
  const [step, setStep] = useState<TChannelStep>(STEP.CLOSED);
  const [selectedChannelType, setSelectedChannelType] =
    useState<TChannelTypeGroup>();
  const [selectedChannelProtocol, setSelectedChannelProtocol] =
    useState<TChannelProtocol>();

  return {
    step,
    setStep,
    selectedChannelType,
    selectedChannelProtocol,
    setSelectedChannelType,
    setSelectedChannelProtocol,
  };
};
